import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-lasuite-forgot-password',
  templateUrl: './lasuite-forgot-password.component.html',
  styleUrls: ['../style/global.css', './lasuite-forgot-password.component.css'],
})
export class LasuiteForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
